<template>
<div style="display: inline;">
    <zm-date-picker size="small"
        class="date-picker-inline"
        v-model="startTs"
        type="datetime"
        :picker-options="fromDatePickerOption"
        range-separator="-"
        placeholder="start time"
        value-format="timestamp"
        @change="setData"
        align="right">
    </zm-date-picker>
    <span> - </span>
    <zm-date-picker size="small"
        class="date-picker-inline"
        v-model="endTs"
        type="datetime"
        :picker-options="toDatePickerOption"
        range-separator="-"
        placeholder="end time"
        value-format="timestamp"
        @change="setData"
        align="right">
    </zm-date-picker>
    <!-- <span class="time-zone">UTC {{ timeZone >= 0 ? '+' + timeZone : timeZone}}</span> -->
    <!-- <zm-input-number size="small" v-model="timeZone" :min="-12" :max="14"></zm-input-number> -->
    <zm-dropdown trigger="click" @command="handleCommandTimeZone"
    style="margin: 0 5px">
        <span class="zm-dropdown-link">
            {{ prefixZero(timeZone, 2) }}
            <!-- UTC {{ timeZone >= 0 ? '+' + timeZone : timeZone}} -->
            <i class="iconfont icon-icon_time-zone_outlined" style="margin-left: 5px;"></i>
        </span>
        <zm-dropdown-menu slot="dropdown" class="time-zone-dropdown">
            <zm-dropdown-item :command="-12">Local</zm-dropdown-item>
            <zm-dropdown-item :command="0">UTC+00:00</zm-dropdown-item>
            <zm-dropdown-item :command="-11">UTC-11:00</zm-dropdown-item>
            <zm-dropdown-item :command="-10">UTC-10:00</zm-dropdown-item>
            <zm-dropdown-item :command="-9">UTC-09:00</zm-dropdown-item>
            <zm-dropdown-item :command="-8">UTC-08:00</zm-dropdown-item>
            <zm-dropdown-item :command="-7">UTC-07:00</zm-dropdown-item>
            <zm-dropdown-item :command="-6">UTC-06:00</zm-dropdown-item>
            <zm-dropdown-item :command="-5">UTC-05:00</zm-dropdown-item>
            <zm-dropdown-item :command="-4">UTC-04:00</zm-dropdown-item>
            <zm-dropdown-item :command="-3">UTC-03:00</zm-dropdown-item>
            <zm-dropdown-item :command="-2">UTC-02:00</zm-dropdown-item>
            <zm-dropdown-item :command="-1">UTC-01:00</zm-dropdown-item>
            <zm-dropdown-item :command="1">UTC+01:00</zm-dropdown-item>
            <zm-dropdown-item :command="2">UTC+02:00</zm-dropdown-item>
            <zm-dropdown-item :command="3">UTC+03:00</zm-dropdown-item>
            <zm-dropdown-item :command="4">UTC+04:00</zm-dropdown-item>
            <zm-dropdown-item :command="5">UTC+05:00</zm-dropdown-item>
            <zm-dropdown-item :command="6">UTC+06:00</zm-dropdown-item>
            <zm-dropdown-item :command="7">UTC+07:00</zm-dropdown-item>
            <zm-dropdown-item :command="8">UTC+08:00</zm-dropdown-item>
            <zm-dropdown-item :command="9">UTC+09:00</zm-dropdown-item>
            <zm-dropdown-item :command="10">UTC+10:00</zm-dropdown-item>
            <zm-dropdown-item :command="11">UTC+11:00</zm-dropdown-item>
            <zm-dropdown-item :command="12">UTC+12:00</zm-dropdown-item>
            <zm-dropdown-item :command="13">UTC+13:00</zm-dropdown-item>
            <zm-dropdown-item :command="14">UTC+14:00</zm-dropdown-item>
        </zm-dropdown-menu>
    </zm-dropdown>
    <zm-dropdown trigger="click" @command="handleCommand" style="margin-right: 5px">
        <span class="zm-dropdown-link">
            <i class="zm-icon-date"></i>
        </span>
        <zm-dropdown-menu slot="dropdown">
            <zm-dropdown-item :command="0">last 5 min</zm-dropdown-item>
            <zm-dropdown-item :command="1">last 30 min</zm-dropdown-item>
            <zm-dropdown-item :command="2">last 1 hour</zm-dropdown-item>
            <zm-dropdown-item :command="3">last 6 hours</zm-dropdown-item>
            <zm-dropdown-item :command="4">last 12 hours</zm-dropdown-item>
            <zm-dropdown-item :command="5">last 1 day</zm-dropdown-item>
            <zm-dropdown-item :command="6">last 1 week</zm-dropdown-item>
            <zm-dropdown-item :command="7">last 30 days</zm-dropdown-item>
        </zm-dropdown-menu>
    </zm-dropdown>
</div>
</template>
<script>
// import timeZoneList from '../../plugins/timezone'
export default {
    name: 'timePickerOption',
    data () {
        return {
            fromDatePickerOption: {
                disabledDate: (time) => {
                    if (this.endTs) {
                        const toDate = this.endTs
                        return time.getTime() > toDate
                    } else {
                        return false
                    }
                }
            },
            toDatePickerOption: {
                disabledDate: (time) => {
                    if (this.startTs) {
                        const fromDate = this.startTs
                        return time.getTime() + 3600 * 1000 * 8 < fromDate
                    } else {
                        return false
                    }
                }
            },
            startTs: '',
            endTs: '',
            timeZone: 0,
            // timeZoneList: timeZoneList,
            timezoneOffset: 0,
            isLocal: true,
            data: [300000, 1800000, 3600000, 21600000, 43200000, 86400000, 604800000, 2592000000]
        }
    },
    created () {
        this.timezoneOffset = (new Date()).getTimezoneOffset()
        this.timeZone = -this.timezoneOffset / 60
        if (this.$route.query.endTs) {
            this.endTs = parseInt(this.$route.query.endTs)
            this.startTs = parseInt(this.$route.query.startTs)
        }
    },
    methods: {
        handleCommand (command) {
            this.endTs = Date.now()
            this.startTs = this.endTs - this.data[command]
            this.setData()
        },
        handleCommandTimeZone (command) {
            if (command === -12) {
                this.isLocal = true
                this.timeZone = -this.timezoneOffset / 60
                this.showSelect = false
            } else {
                this.timeZone = command
            }
            this.setData()
        },
        setData () {
            // if (this.startTs && this.endTs) {
            const start = this.startTs ? this.startTs - this.timezoneOffset * 60 * 1000 - this.timeZone * 60 * 60 * 1000 : ''
            const end = this.startTs ? this.endTs - this.timezoneOffset * 60 * 1000 - this.timeZone * 60 * 60 * 1000 : ''
            this.$emit('setTimeRange', [start, end], this.timeZone)
            // }
        },
        prefixZero (num, n) {
            return num >= 0 ? 'UTC+' + (Array(n).join(0) + num).slice(-n) + ':00' : 'UTC-' + (Array(n).join(0) + (0 - num)).slice(-n) + ':00'
        },
        refreshDate () {
            const dateLength = this.endTs - this.startTs
            const end = (new Date()).getTime()
            const start = end - dateLength
            this.endTs = end
            this.startTs = start
            this.setData()
        }
    }
}
</script>
<style>
.date-picker-inline.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner {
    width: 190px;
    font-size: 13px;
}
.date-picker-inline-to.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner {
    width: 260px;
    font-size: 13px;
}
.time-zone {
    color: #333;
}
/* .time-zone-dropdown.zm-dropdown-menu .zm-popper ul {
    max-height: 60vh;
    overflow-y: scroll;
} */
.time-zone-dropdown.zm-dropdown-menu {
    max-height: 80vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>
